import { ColumnDefWithTooltip } from "src/components/Table/Table";
import { ColumnId } from "./constants";

type Row = {
  id: { formId: uuid };
  schoolForm: {
    offer: {
      program: {
        id: uuid;
        name: string;
      } | null;
    } | null;
  } | null;
};

const getProgramColumnProps = (columnId: ColumnId) => {
  switch (columnId) {
    case ColumnId.Program:
      return {
        header: "Program",
        valueFn: (schoolForm: Row["schoolForm"]) =>
          schoolForm?.offer?.program?.name,
      };
    case ColumnId.ProgramId:
      return {
        header: "Program ID",
        valueFn: (schoolForm: Row["schoolForm"]) =>
          schoolForm?.offer?.program?.id,
      };
    default:
      throw new Error(`Unknown column ID: ${columnId}`);
  }
};

export function buildProgramColumnDef<T extends Row>(
  columnId: ColumnId
): ColumnDefWithTooltip<T> {
  const { header, valueFn } = getProgramColumnProps(columnId);
  return {
    accessorFn: (row) => valueFn(row.schoolForm),
    id: columnId,
    header,
  };
}
